import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Button from "../Button";
import dayjs from "dayjs";

interface Props {
  date: any;
  onBlock: any;
}

const DateBlocked = ({ date, onBlock }: Props) => {
  return (
    <StyledDateBlockContainer>
      <BlockedImage src={require("../../assets/images/blocked.png")} />
      <StyledBlockedTextHeader>
        Date is Blocked by Admin
      </StyledBlockedTextHeader>
      <StyledBlockedText>
        According to the advice from the Water Activity Weather Guard, we should
        initiate a closure on {dayjs(date).format("MMM D, YYYY")}.
      </StyledBlockedText>
      <Button
        label="UnBlock Date"
        variant="filled"
        width="10rem"
        color={Colors.red}
        onClick={onBlock}
      />
    </StyledDateBlockContainer>
  );
};

const StyledDateBlockContainer = styled.div`
  width: 100%;
  height: 40rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    height: 30rem;
  }
`;

const StyledBlockedTextHeader = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
`;

const StyledBlockedText = styled.div`
  width: 40%;
  text-align: center;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;

const BlockedImage = styled.img`
  width: 20%;
  @media only screen and (max-width: 768px) {
    width: 60%;
  }
`;

export default DateBlocked;
